<div class="dm-page-content mb-25">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <app-back-button />
        <div class="page-header">
          <div class="left-area">
            <span class="title">Acordos de Formação</span>
            <span class="sub-title">Adicione, consulte e edite programas de formação</span>
          </div>
          <div class="indicator" *ngIf="programasCount">
            <div class="indicator">
              <div class="icon">
                <img src="icons/certificate-01.svg" alt="Country Icon" />
              </div>
              <div class="text-bg">
                <span>{{programasCount}} Acordos de Formação</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-search-bar [sortFields]="sortFields" [showFilterBtn]="true" (onFilterBtnClick)="showFilterModal()"
        [showPrimaryBtn]="false" (formValueChange)="handleFormValueChange($event)"></app-search-bar>
      <div class="row">
        <ng-container *ngIf="pagination.data; else noData">
          <app-table [pagination]="pagination" [columns]="columns" [actions]="actions"
            (pageChange)="onPageChange($event)">
          </app-table>
        </ng-container>

        <ng-template #noData>
          <div class="no-data">
            <app-data-void titulo="Nenhum Programa de Formação encontrado"
              descricao="Clique em Novo Programa para criar um."></app-data-void>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
<p-toast></p-toast>

<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
      </p-select>

      <!-- Se for texto -->
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />
    </div>
  </form>


  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>